import { IGetState, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import {
    getPushToGoogleCalendarCardId
} from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/selectors/getPushToGoogleCalendarCardId';
import pushToGoogleCalendarSelectCard
    from '../../../../../../aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/store/actions/pushToGoogleCalendarSelectCard';

export const onDidMount = (
    cardId: TCardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (getPushToGoogleCalendarCardId(getState()) !== cardId) { // dispatches optimization
            dispatch(pushToGoogleCalendarSelectCard(cardId));
        }
    };
    return action;
};
